import axios from 'axios';
import { API_NOTIFICATION_BASE_URL } from '../apiConstant';

const BASE = `${API_NOTIFICATION_BASE_URL}/api/notification`;

/**
 * Register this device to receive push notifications.
 * @param {string} deviceToken - FCM token
 */
export const registerDevice = (deviceToken) =>
  axios.post(`${BASE}/register-device`, {
    deviceToken,
    deviceType: 'WEB',
  });

/**
 * Fetch the authenticated user's notification history (~last 50).
 */
export const fetchNotificationHistory = (page = 0, size = 10, filter = 'ALL') =>
  axios.get(`${BASE}/notificationHistory`, {
    params: { page, size, filter },
  });

/**
 * Unregister this device (called on logout).
 * @param {string} deviceToken - FCM token to clear
 */
export const logoutDevice = (deviceToken) =>
  axios.post(`${BASE}/logout`, { deviceToken });

/**
 * Mark a single notification as read.
 * @param {number|string} id - Notification ID
 */
export const markNotificationRead = (id) =>
  axios.patch(`${BASE}/notificationHistory/${id}/read`);

/**
 * Mark all notifications as read.
 */
export const markAllNotificationsRead = () =>
  axios.patch(`${BASE}/notificationHistory/read-all`);

/**
 * Fetch the total unread notifications count.
 */
export const fetchUnreadNotificationCount = () =>
  axios.get(`${BASE}/notificationHistory/unread-count`);

